module.exports = __webpack_public_path__ + "static/img/steps_3_1.5bf98dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfc/steps_3_1.png
// module id = gK7q
// module chunks = 0